module.exports = __webpack_public_path__ + "img/face_shape_female_rect.01a2a80d.png";